import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const ROLE_LABELS = {
  consiglio: "Consiglio",
  fondatori: "Socio Fondatore",
  tesoriere: "Tesoriere",
  segretario: "Segretario",
  tesseramento: "Tesseramento",
  soci: "Socio",
  collaboratori: "Collaboratore",
  donatore: "Socio Donatore",
  tutti: "Tutti",
};

// Etichette delle sezioni del calendario
export const SECTION_LABELS = {
  tutti: "Eventi per tutti",
  consiglio: "Riunioni Consiglio",
  fondatori: "Riunioni Fondatori",
  soci: "Riunioni Soci",
  collaboratori: "Riunioni Collaboratori",
};

// Sezioni calendario visibili per ruolo (stessa logica del backend)
export function visibleSections(user) {
  if (!user) return ["tutti"];
  if (user.is_admin || ["consiglio", "tesoriere", "segretario"].includes(user.role)) return ["tutti", "consiglio", "fondatori", "soci", "collaboratori"];
  if (user.role === "tesseramento") return ["tutti", "fondatori", "soci", "collaboratori"];
  if (user.role === "fondatori") return ["tutti", "fondatori", "soci", "collaboratori"];
  if (user.role === "soci") return ["tutti", "soci"];
  if (user.role === "collaboratori") return ["tutti", "collaboratori"];
  return ["tutti"];
}

export const TRANSPARENCY_CATEGORIES = {
  bilancio: "Bilancio",
  statuto: "Statuto",
  elezioni: "Risultati Elezioni",
  verbale: "Verbale Riunione",
  regolamento: "Regolamento Interno",
  convenzione: "Convenzioni",
  altro: "Altro",
};

export const VISIBILITY_LABELS = {
  public: "Pubblico (WordPress + tutti)",
  soci: "Solo Soci",
  consiglio: "Solo Consiglio",
};

export const roleClass = (r) => `role-${r || "tutti"}`;

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("it-IT", {
      day: "2-digit", month: "short", year: "numeric",
    });
  } catch { return iso; }
}

export function formatDateTime(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("it-IT", {
      day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit"
    });
  } catch { return iso; }
}

export function euro(n) {
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n || 0);
}
